import 'daterangepicker'
import 'datetimepicker'

var start_date = $("#timeslot_start_date").val();
var end_date = $("#timeslot_end_date").val();
$('#organisationTimeslotDatepicker').daterangepicker({
    "singleDatePicker": true,
    "startDate": start_date,
    "minDate": start_date,
    "maxDate": end_date,
})
